enum InvoiceConstants {
  GET_INVOICES_REQUEST = "GET_INVOICES_REQUEST",
  GET_INVOICES_SUCCESS = "GET_INVOICES_SUCCESS",
  GET_INVOICES_FAILURE = "GET_INVOICES_FAILURE",

  GET_INVOICE_DETAILS_REQUEST = "GET_INVOICE_DETAILS_REQUEST",
  GET_INVOICE_DETAILS_SUCCESS = "GET_INVOICE_DETAILS_SUCCESS",
  GET_INVOICE_DETAILS_FAILURE = "GET_INVOICE_DETAILS_FAILURE",

  SEND_INVOICE_REQUEST = "SEND_INVOICE_REQUEST",
  SEND_INVOICE_SUCCESS = "SEND_INVOICE_SUCCESS",
  SEND_INVOICE_FAILURE = "SEND_INVOICE_FAILURE",

  CREATE_INVOICE_REQUEST = "CREATE_INVOICE_REQUEST",
  CREATE_INVOICE_SUCCESS = "CREATE_INVOICE_SUCCESS",
  CREATE_INVOICE_FAILURE = "CREATE_INVOICE_FAILURE",

  UPDATE_INVOICE_REQUEST = "UPDATE_INVOICE_REQUEST",
  UPDATE_INVOICE_SUCCESS = "UPDATE_INVOICE_SUCCESS",
  UPDATE_INVOICE_FAILURE = "UPDATE_INVOICE_FAILURE",

  RESET_INVOICES = "RESET_INVOICES",
  RESET_INVOICE_SENT = "RESET_INVOICE_SENT",
}

export default InvoiceConstants;
